import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import { Formik, Form } from 'formik';

import Button from 'uikit/Button';

import styles from './QuestionPreview.module.scss';

const cx = classNames.bind(styles);

const QuestionPreview = ({
  handleBack,
  handleToggleCard,
  initialValues,
  question,
  rectoComponent: RectoQuestion,
  seeRecto,
  t,
  versoComponent: VersoQuestion,
}) => (
  <div className={cx('container')}>
    <div className={cx('buttons')}>
      <Button
        className={cx('left')}
        icon="arrow-left"
        onClick={() => handleBack(null)}
        size="large"
        tooltip={t(
          'Course/Teacher/Editor/QuestionImport/QuestionImportPublicCourses/QuestionImporter/QuestionPreview/back',
        )}
      />
      <Button className={cx('flip')} icon="repeat" onClick={handleToggleCard}>
        {seeRecto
          ? t(
              'Course/Teacher/Editor/QuestionImport/QuestionImportPublicCourses/QuestionImporter/QuestionPreview/see-verso',
            )
          : t(
              'Course/Teacher/Editor/QuestionImport/QuestionImportPublicCourses/QuestionImporter/QuestionPreview/see-recto',
            )}
      </Button>
    </div>
    <p className={cx('explanation')}>
      {t(
        'Course/Teacher/Editor/QuestionImport/QuestionImportPublicCourses/QuestionImporter/QuestionPreview/explanation',
      )}
    </p>
    <Formik
      initialValues={initialValues}
      key={question.id}
      onSubmit={() => null}
      validateOnBlur={false}
      validateOnChange={false}
    >
      {() => (
        <Form>
          {seeRecto
            ? RectoQuestion && <RectoQuestion question={question} />
            : VersoQuestion && <VersoQuestion question={question} />}
        </Form>
      )}
    </Formik>
  </div>
);

QuestionPreview.propTypes = {
  handleBack: PropTypes.func.isRequired,
  handleToggleCard: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  question: PropTypes.object,
  rectoComponent: PropTypes.elementType,
  seeRecto: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
  versoComponent: PropTypes.elementType,
};

QuestionPreview.defaultProps = {
  question: undefined,
  rectoComponent: undefined,
  versoComponent: undefined,
};

export default QuestionPreview;
